import { render, staticRenderFns } from "./list.vue?vue&type=template&id=e4f3277e&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=e4f3277e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f3277e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\Code\\Code-ycode\\LegalSystem\\代码管理\\SinyiLegal_M\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4f3277e')) {
      api.createRecord('e4f3277e', component.options)
    } else {
      api.reload('e4f3277e', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=e4f3277e&scoped=true&", function () {
      api.rerender('e4f3277e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/board/list.vue"
export default component.exports